import React, { useState } from 'react';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ClientsSection from './components/ClientsSection';
import WelcomeSection from './components/WelcomeSection';
import TestimonialsSection from './components/TestimonialsSection';
import PartnershipsSection from './components/PartnershipsSection';
import Footer from './components/Footer';
import LoginModal from './components/LoginModal';
import AdminDashboard from './components/admin/AdminDashboard';
import CheckoutPage from './components/checkout/CheckoutPage';
import CheckoutSuccessPage from './components/checkout/CheckoutSuccessPage';
import CourseDetailsPage from './components/course/CourseDetailsPage';
import FormationDetailsPage from './components/formation/FormationDetailsPage';
import MethodologyPage from './components/methodology/MethodologyPage';
import RevitAssessmentPage from './components/assessment/RevitAssessmentPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import ExamPage from './components/exam/ExamPage';
import CertificatePage from './components/exam/CertificatePage';
import MyCertificatesPage from './components/exam/MyCertificatesPage';
import ValidateCertificatePage from './components/exam/ValidateCertificatePage';
import RankingPage from './components/ranking/RankingPage';
import AcademyPage from './components/pages/AcademyPage';
import ConsultoriaPage from './components/pages/ConsultoriaPage';
import MentorPage from './components/pages/MentorPage';
import LibraryPage from './components/pages/LibraryPage';
import ProjetosPage from './components/pages/ProjetosPage';
import ConnectPage from './components/pages/ConnectPage';
import DigitalTwinPage from './components/pages/DigitalTwinPage';
import BIMMapPage from './components/bimmap/BIMMapPage';
import BimIAPage from './components/bimia/BimIAPage';
import SharedBimIAPage from './components/bimia/SharedBimIAPage';
import PremiumThankYouPage from './components/bimmap/PremiumThankYouPage';
import CreateConnectProfilePage from './components/pages/CreateConnectProfilePage';
import ConnectProfilePage from './components/pages/ConnectProfilePage';
import EditConnectProfilePage from './components/pages/EditConnectProfilePage';
import FeedPage from './components/pages/FeedPage';
import JobsPage from './components/pages/JobsPage';
import MessagesPage from './components/pages/MessagesPage';
import ConnectPlansPage from './components/pages/ConnectPlansPage';
import GaleriaPage from './components/pages/GaleriaPage';
import ObrigadoPage from './components/pages/ObrigadoPage';
import InscricaoRecebidaPage from './components/pages/InscricaoRecebidaPage';
import PortalAlunoPage from './components/pages/PortalAlunoPage';
import BimtalksPage from './pages/BimtalksPage';
import ServicesTestPage from './pages/ServicesTestPage';
import SobreEmpresaPage from './pages/SobreEmpresaPage';
import RevitExpertPage from './pages/RevitExpertPage';
import WhatsAppButton from './components/WhatsAppButton';
import AssistantWidget from './components/AssistantWidget';
import SEO from './components/SEO';
import { Toaster } from 'sonner';

function HomePage({ setIsLoginModalOpen }) {
  return (
    <>
      <SEO 
        title="BIMPortal - Seu Portal de Serviços BIM"
        description="Líder em Educação BIM no Brasil. Cursos, consultoria, projetos e conteúdo gratuito sobre BIM e Revit. +12.000 alunos formados desde 2005."
        keywords="BIM, Revit, cursos BIM, Autodesk, Navisworks, consultoria BIM, projetos BIM"
      />
      <Header onLoginClick={() => setIsLoginModalOpen(true)} />
      <HeroSection />
      <WelcomeSection />
      <ClientsSection />
      <TestimonialsSection />
      <PartnershipsSection show="partners" />
      <PartnershipsSection show="institutional" />
      <Footer />
    </>
  );
}

function App() {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  return (
    <HelmetProvider>
      <AuthProvider>
        <CurrencyProvider>
        <BrowserRouter>
          <div className="App bg-black min-h-screen">
            <Routes>
              <Route path="/" element={<HomePage setIsLoginModalOpen={setIsLoginModalOpen} />} />
              <Route path="/connect" element={<ConnectPage />} />
              <Route path="/digital-twin" element={<DigitalTwinPage />} />
              <Route path="/bimmap" element={<BIMMapPage />} />
              <Route path="/bim-ia" element={<BimIAPage />} />
              <Route path="/bim-ia/c/:token" element={<SharedBimIAPage />} />
              <Route path="/bimmap/premium/obrigado" element={<PremiumThankYouPage />} />
              <Route path="/academy" element={<AcademyPage />} />
              <Route path="/consultoria" element={<ConsultoriaPage />} />
              <Route path="/mentor" element={<MentorPage />} />
              <Route path="/bim-library" element={<LibraryPage />} />
              <Route path="/projetos" element={<ProjetosPage />} />
              <Route path="/galeria" element={<GaleriaPage />} />
              <Route path="/obrigado" element={<ObrigadoPage />} />
              <Route path="/inscricao-recebida" element={<InscricaoRecebidaPage />} />
              <Route path="/portal" element={<PortalAlunoPage />} />
              <Route path="/bimtalks" element={<BimtalksPage />} />
              <Route path="/services-test" element={<ServicesTestPage />} />
              <Route path="/sobre-empresa" element={<SobreEmpresaPage />} />
              <Route path="/revitexpert" element={<RevitExpertPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/metodologia" element={<MethodologyPage />} />
              <Route path="/avaliacao-revit" element={<RevitAssessmentPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/course/:courseId" element={<CourseDetailsPage />} />
              <Route path="/formation/:formationId" element={<FormationDetailsPage />} />
              <Route path="/checkout/:bundleId/:modality" element={<CheckoutPage />} />
              <Route path="/checkout/course/:courseId/:modality" element={<CheckoutPage />} />
              <Route path="/checkout/success/:enrollmentId" element={<CheckoutSuccessPage />} />
              <Route path="/exam/:courseId" element={<ExamPage />} />
              <Route path="/certificate/:certificateId" element={<CertificatePage />} />
              <Route path="/meus-certificados" element={<MyCertificatesPage />} />
              <Route path="/validar" element={<ValidateCertificatePage />} />
              <Route path="/validar/:code" element={<ValidateCertificatePage />} />
              <Route path="/ranking" element={<RankingPage />} />
              
              {/* BIM Connect Routes */}
              <Route path="/connect/create-profile" element={<CreateConnectProfilePage />} />
              <Route path="/connect/profile/:profileId" element={<ConnectProfilePage />} />
              <Route path="/connect/profile/:profileId/edit" element={<EditConnectProfilePage />} />
              <Route path="/connect/feed" element={<FeedPage />} />
              <Route path="/connect/jobs" element={<JobsPage />} />
              <Route path="/connect/messages" element={<MessagesPage />} />
              <Route path="/connect/messages/:partnerId" element={<MessagesPage />} />
              <Route path="/connect/plans" element={<ConnectPlansPage />} />
            </Routes>
            <LoginModal isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
            <WhatsAppButton />
            <AssistantWidget />
            <Toaster position="top-right" />
          </div>
        </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;